<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'
  import { useCurrencyList } from '@/models/currency'

  defineProps<{
    label?: string,
  }>()

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const { currencies, loading, getData } = useCurrencyList()
  getData({ search: undefined })

  const selectedCurrency = computed({
    set: (currency?: string) => updateRoute({ currency }),
    get: () => route.query.currency as string | undefined,
  })

  const filteredCurrencies = computed(() => {
    return currencies.value
  })
</script>

<template>
  <app-select
    v-model="selectedCurrency"
    :label="label ?? 'Mata Uang'"
    :loading="loading">
    <option :value="undefined">
      Semua
    </option>
    <option
      v-for="currency in filteredCurrencies"
      :key="currency.id"
      :value="currency.code">
      {{ currency.code }}
    </option>
  </app-select>
</template>
